import getCopilotPlatforms from "~/operatorApplication/ts/service/copilot/getCopilotPlatforms";

export default function getCopilotsBySite(site: OperatorApplicationApi.OperatorGetParamsSiteOpenApiModel) {
    let copilotPlatformIds = getCopilotPlatforms().map(platform => platform.id);
    return site.integrations.filter(auth => copilotPlatformIds.includes(auth.platformId));
}